/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageVisibility } from 'react-page-visibility';
import Button from '../../components/Button/Button';
import PlainButton from '../../components/Button/PlainButton/PlainButton';
import FeedbackFormModal from './FeedbackFormModal';
import './FeedbackForm.scss';
import { useSelector } from 'react-redux';

const FeedbackForm = (props) => {
    const { t } = useTranslation()
    const isVisible = usePageVisibility()
    const [reminderShown, setReminderShown] = useState(false);
    const [modalShown, setModalShown] = useState(false);
    const [timer, setTimer] = useState(null);
    const sidebarShown = useSelector((state) => state.feedbackForm.sidebarShown)

    const incrementWindowFocusedAndCheckIfExceed30Min = () => {
        const currentFocusedTime = Number(localStorage.getItem('window_focused_in_second'));
        localStorage.setItem('window_focused_in_second', currentFocusedTime + 1);

        checkWindowIsFocusedMoreThan30Min()
    }

    const checkWindowIsFocusedMoreThan30Min = () => {
        const windowFocusedTime = Number(localStorage.getItem('window_focused_in_second'));
        if (!reminderShown && windowFocusedTime > 30 * 60) {
            setReminderShown(true);
        }
    }

    useEffect(() => {
        if (isVisible) setTimer(setInterval(incrementWindowFocusedAndCheckIfExceed30Min, 1000))
        else clearInterval(timer)
    }, [isVisible])

    useEffect(() => {
        if (localStorage.getItem('window_focused_in_second') == null) {
            localStorage.setItem('window_focused_in_second', 0);
        }
        checkWindowIsFocusedMoreThan30Min();
    }, []);

    if (modalShown) {
        return (
            <FeedbackFormModal
                closeModal={() => {
                    setModalShown(false);
                    setReminderShown(false);
                    localStorage.setItem('window_focused_in_second', 0);
                }}
            />
        );
    }

    // if reminder and sidebar content not in same return animation will be strange
    return (
        <>
            {
                !reminderShown && (
                    <div
                        className={`feedback-form ${sidebarShown ? 'sidebar__open' : 'sidebar__close'}`}
                        style={{
                            width: sidebarShown ? 280 : 77,
                            borderTop: sidebarShown ? '1px solid #CFD9E2' : '',
                        }}
                    >
                        <div
                            className="title-section"
                            onClick={() => {
                                setModalShown(true);
                            }}
                        >
                            <i className="ic-archive-box-v2" style={{ width: 28, height: 28 }} />
                            { sidebarShown && (
                                <span className="feedback-form-title">{t('feedbackForm.title')}</span>
                            )}
                        </div>
                    </div>
                )}

            {
                reminderShown && (
                    <div className="feedback-form-reminder fade-in">
                        <div
                            className="title-section"
                        >
                            <i className="ic-archive-box" style={{ width: 28, height: 28 }} />
                            <div className="feedback-form-title">{t('feedbackForm.titleReminder')}</div>
                            <i
                                className="ic-caret-down"
                                style={{ width: 28, height: 28, cursor: 'pointer' }}
                                onClick={() => {
                                    setReminderShown(false)
                                    localStorage.setItem('window_focused_in_second', 0);
                                }}
                            />
                        </div>
                        <div>
                            <div className="message-section">
                                {t('feedbackForm.message')}
                            </div>
                            <div className="form-actions">
                                <PlainButton
                                    size="medium"
                                    onClick={() => {
                                        setReminderShown(false)
                                        localStorage.setItem('window_focused_in_second', 0);
                                    }}
                                >
                                    {t('feedbackForm.skip')}
                                </PlainButton>
                                <Button
                                    className="button-submit"
                                    size="medium"
                                    onClick={() => {
                                        setReminderShown(false);
                                        setModalShown(true);
                                    }}
                                >
                                    {t('feedbackForm.sendFeedback')}
                                </Button>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default FeedbackForm;